// BabyMobile.ca — quick-view modal for catalog cards, populated from the
// clicked card's data-qv-* attributes (no extra network request).
(function () {
  var overlay = document.querySelector('[data-rd-qv-overlay]');
  if (!overlay) return;

  var imgEl = overlay.querySelector('[data-rd-qv-img]');
  var catEl = overlay.querySelector('[data-rd-qv-cat]');
  var nameEl = overlay.querySelector('[data-rd-qv-name]');
  var priceEl = overlay.querySelector('[data-rd-qv-price]');
  var descEl = overlay.querySelector('[data-rd-qv-desc]');
  var addBtn = overlay.querySelector('[data-rd-qv-add]');
  var detailsLink = overlay.querySelector('[data-rd-qv-details]');

  function open(btn) {
    imgEl.src = btn.getAttribute('data-qv-img') || '';
    imgEl.alt = btn.getAttribute('data-qv-name') || '';
    catEl.textContent = btn.getAttribute('data-qv-cat') || '';
    nameEl.textContent = btn.getAttribute('data-qv-name') || '';
    priceEl.textContent = btn.getAttribute('data-qv-price') || '';
    descEl.textContent = btn.getAttribute('data-qv-desc') || '';
    addBtn.setAttribute('data-variant-id', btn.getAttribute('data-variant-id') || '');
    addBtn.setAttribute('data-product-id', btn.getAttribute('data-product-id') || '');
    detailsLink.href = btn.getAttribute('data-qv-url') || '#';

    overlay.hidden = false;
    document.body.classList.add('rd-qv-open');
  }

  function close() {
    overlay.hidden = true;
    document.body.classList.remove('rd-qv-open');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-rd-quick-view]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      open(trigger);
      return;
    }

    if (e.target.closest('[data-rd-qv-close]')) {
      e.preventDefault();
      close();
      return;
    }

    if (e.target.closest('[data-rd-qv-add]')) {
      close();
      return;
    }

    if (e.target === overlay) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) close();
  });
})();
